export default{
	state:{
		news:{
			newsNoRead:0,//未读消息
			newsIsRead:0,//已读消息
			newsAll:0//全部消息
		}
	},
	mutations:{
		SETNEWSNUM(state,newVal){
			state.news.newsNoRead = newVal.newsNoRead
			state.news.newsIsRead = newVal.newsIsRead
			state.news.newsAll = Number(state.news.newsIsRead)+Number(state.news.newsNoRead) 
			
		},
		CHANGENEWSNUM(state){
			
		}
	}
}


// WEBPACK FOOTER //
// ./src/store/modules/news.js